import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import ExportCsv from './ExportCsv';
import PublishToCustomerPortal from './PublishToCustomerPortal';

const namespace = 'features.proposals.index.mass_actions';

function MassActions({ state, onSelectAll, queryParams, hideExport, hasShowAllProposalsInCustomerPortal }) {
  const { data: proposals, selectAll, totalCount } = state;
  const selectedProposals = proposals.filter((proposal) => proposal.selected);
  const disabled = selectedProposals.length === 0;
  const proposalsCount = selectAll ? totalCount : selectedProposals.length;
  const proposalIds = selectedProposals.map((proposal) => proposal.id).join();

  return (
    <div className="qmb-actions">
      {!disabled && (
        <div className="actions__group--selection">
          <button type="button" className="actions__selection">
            <span className="actions__count">{proposalsCount}</span>
          </button>
          {!selectAll && (
            <div className="actions__entire">
              <button type="button" tabIndex="0" className="qmb-control--sm" onClick={onSelectAll}>
                {translate('selected_global_counter', { namespace, count: totalCount })}
              </button>
            </div>
          )}
        </div>
      )}

      <div className="actions__group">
        {!hideExport && (
          <ExportCsv disabled={disabled} proposalIds={!selectAll && proposalIds} queryParams={queryParams} />
        )}
        {!hasShowAllProposalsInCustomerPortal && (
          <PublishToCustomerPortal
            proposalsCount={proposalsCount}
            proposalIds={!selectAll && proposalIds}
            disabled={disabled}
            queryParams={queryParams}
          />
        )}
      </div>
    </div>
  );
}

MassActions.propTypes = {
  state: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    totalCount: PropTypes.number,
    selectAll: PropTypes.bool
  }).isRequired,
  onSelectAll: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
  hideExport: PropTypes.bool.isRequired,
  hasShowAllProposalsInCustomerPortal: PropTypes.bool.isRequired
};

export default MassActions;
